import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import classNames from 'classnames'
import RouterLink from 'base/components/router_link'

function TermsOfService({
  leftAlign,
  noLineBreak,
  showWelcomeOfferDisclaimer,
  isPlacingOrder = false,
}) {
  const tosClass = classNames('gdpr__terms-text', {
    'gdpr__terms-text--left-aligned': leftAlign,
  })

  const tosContext = isPlacingOrder ? 'placing an order' : 'providing your email address'

  return (
    <p className={tosClass}>
      {showWelcomeOfferDisclaimer && (
        <Fragment>
          <span>20% off applies only to full price items.</span>
          <br />
        </Fragment>
      )}
      By {tosContext}, you agree to our {!noLineBreak && <br />}
      <RouterLink href="/privacy" className="gdpr__terms-link" target="_blank">
        Privacy Policy
      </RouterLink>{' '}
      and{' '}
      <RouterLink href="/terms" className="gdpr__terms-link" target="_blank">
        Terms of Service
      </RouterLink>
      .
    </p>
  )
}

TermsOfService.propTypes = {
  leftAlign: PropTypes.bool,
  noLineBreak: PropTypes.bool,
  isPlacingOrder: PropTypes.bool,
}

export default TermsOfService
